import { z } from 'zod';

export const schema = z.array(z.string());
